var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrapper-page',{attrs:{"ignoreSubscriptionStatus":true}},[_vm._v(" Your payment method has been set up and will be used for your next payment ")])
}
var staticRenderFns = []

export { render, staticRenderFns }